// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"38399e2e","149":"6ad52921"}[chunkId] + ".chunk.css";
};